import axios from '../../axios'

const currentHostname = window.location.hostname;

export default {
	state: {
		uid: null,
		logo: null,
		presentationPdf: null,
		colors: null,
		// staffUrl: "forschungsakademie.com",
		// staffUrl: "copywriters-front.avada-media-dev1.od.ua",
		staffUrl: "localhost",
		currentHostname: currentHostname,
		// staffLoginLogo: "https://copywriters.avada-media-dev1.od.ua/upload/202104/30/1452/illustration_5f49c38d.svg"
	},
	getters: {
		isClientUrl: state => {
			return state.staffUrl !== state.currentHostname;
		},
		websiteLogo: (state, getters, rootState) => {
			return state.logo || rootState.auth.user.website_logo;
		},
		websitePresentationPdf: (state, getters, rootState) => {
			return state.presentationPdf || rootState.auth.user.websitePresentationPdf;
		}
	},
	mutations: {
		changeUid(state, payload) {
			state.uid = payload;
		},
		changeLogo(state, payload) {
			state.logo = payload;
		},
		changePresentationPdf(state, payload) {
			state.presentationPdf = payload;
		},
		changeColors(state, payload) {
			state.colors = payload;
		}
	},
	actions: {
		async updateWebsiteInfo(context) {
			// const url = `/client/auth/get-website-info?domain=${context.state.currentHostname}`;
			// let result = (await axios.get(url)).data.data;

			// // console.log(result);

			// const colors = {
			// 	theme_color_main: result.theme_color_main,
			// 	theme_color_secondary: result.theme_color_secondary
			// };

			// context.commit("changeUid", result.uid);
			// context.commit("changeLogo", result.logo);
			// context.commit("changeColors", colors);
		},
	}
};
